import { FieldType } from '@/constants/fieldType'
import { CNPJ_FORMAT_ERROR, CNPJ_FORMAT_REGEX } from '@/constants/cnpj'

export function isFilled(field: any): boolean {
    if (field === null) {
        return false
    }

    return (
        (typeof(field) === 'number' && field !== 0) ||
        (typeof(field) === 'string' && field.length !== 0)
    )
}

export function getFieldError(value: any, type: string = FieldType.TEXT): string {
    // Erro de campo de texto vazio
    if (type !== FieldType.SELECT && !isFilled(value)) {
        return 'Este campo deve ser preenchido'

    // Erro de campo de seleção vazio
    } else if (type === FieldType.SELECT && !isFilled(value)) {
        return 'Este campo deve ser selecionado'

    // Erro de campo de CPF
    } else if (type === FieldType.CPF && !value.match(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/)) {
        return 'Este campo deve estar no formato xxx.xxx.xxx-xx'

    // Erro de campo de CNPJ
    } else if (type === FieldType.CNPJ && !value.match(CNPJ_FORMAT_REGEX)) {
        return CNPJ_FORMAT_ERROR

    // Erro de campo numérico
    } else if (type === FieldType.NUMBER && !value.match(/^[0-9]+$/)) {
        return 'Este campo deve conter apenas números'

    // Erro de campo de email
    } else if (type === FieldType.EMAIL && !value.match(/^[a-z0-9.]+@[a-z0-9]+(\.[a-z]+){1,2}$/)) {
        return 'Este campo deve estar no formato xxxx@xxxx.xxx'

    // Erro de campo de telefone
    } else if (type === FieldType.PHONE && !value.match(/^\(\d{2}\)\s?\d{4,5}\-\d{4}$/)) {
        return 'Este campo deve estar no formato (xx)xxxxx-xxxx'

    // Erro de campo de data
    } else if (type === FieldType.DATE && !value.match(/^\d{2}\/\d{2}\/(\d{2}|\d{4})$/)) {
        return 'Este campo deve estar no formato xx/xx/xxxx'
    }

    return ''
}
